/**
 * Corpo da resposta de uma Edge Function, inclusive quando ela responde erro.
 *
 * `supabase.functions.invoke` entrega `data: null` em QUALQUER status fora do
 * 2xx e guarda a resposta em `error.context` (um Response). Sem desembrulhar,
 * toda falha do servidor vira a mesma frase genérica na tela — foi assim que
 * "assento ocupado" e "senha não confere" apareceram iguais pro aluno, que
 * ficava tentando a credencial certa.
 *
 * Vive aqui, e não dentro de uma tela, porque a armadilha vale pra TODO
 * `invoke` do app: a tela do aluno, o console do professor e o provisionamento
 * de turma chamam as mesmas funções e precisam ler o erro da mesma forma.
 */
export interface RespostaDaFunction {
  error?: string;
  assentoOcupado?: boolean;
  [chave: string]: unknown;
}

export async function lerRespostaDaFunction(
  data: unknown,
  error: unknown,
): Promise<RespostaDaFunction | null> {
  if (data && typeof data === 'object') return data as RespostaDaFunction;

  const contexto = (error as { context?: Response } | null)?.context;
  if (contexto && typeof contexto.json === 'function') {
    try {
      return await contexto.json();
    } catch {
      return null; // resposta sem corpo JSON (timeout, 502 do gateway)
    }
  }
  return null;
}
